import { Button, EmptyView } from '@carboncopyco/ui';

import { SearchNoMatchIllustration } from '@carboncopyco/illustrations';
import { useWorkspacesPage } from './WorkspacesPageContext';

export const WorkspacesPageEmpty = () => {
  const { clearAll } = useWorkspacesPage();
  return (
    <div className="w-full h-full flex flex-col justify-center items-center gap-2">
      <EmptyView
        noPadding
        title="No results"
        message="Nothing matches your current search"
        illustration={<SearchNoMatchIllustration />}
      />
      <Button
        label="Clear all"
        link
        onClick={clearAll}
      />
    </div>
  );
};
